export default __webpack_public_path__ + "static/media/style.module.e385e093.less";